import { Link } from 'react-router-dom';

export interface CrumbItem {
  label: string;
  to?: string;
}

interface BreadcrumbProps {
  items: CrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="flex flex-wrap items-center gap-1.5 text-sm text-foreground-600">
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        return (
          <span key={item.label} className="flex items-center gap-1.5">
            {index > 0 && <i className="ri-arrow-right-s-line text-foreground-300" aria-hidden="true" />}
            {item.to && !isLast ? (
              <Link to={item.to} className="whitespace-nowrap transition-colors hover:text-primary-600">
                {item.label}
              </Link>
            ) : (
              <span className="whitespace-nowrap text-foreground-950" aria-current="page">
                {item.label}
              </span>
            )}
          </span>
        );
      })}
    </nav>
  );
}